import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import VehicleCompactList from "../components/VehicleCompactList";

// Parent route element for the Vehicle master-detail split - fourth module
// on this pattern after Employee Master, Customers, and Products.
const VehicleSplitView = () => <MasterDetailLayout list={<VehicleCompactList />} />;

export default VehicleSplitView;
